import { createRouter, createWebHistory } from "vue-router"; //createWebHistory       createWebHashHistory
import vue from "vue";
import home from "@/pages/home.vue";
import overview from "@/pages/overview.vue";
import areas from "@/pages/areas.vue";
import newsList from "@/pages/newsList.vue";
import corporateCulture from "@/pages/corporateCulture.vue";
import contactUs from '@/pages/contactUs.vue'
import recruit from '@/pages/recruit.vue'
import essay from '@/pages/essay.vue'
import businessDetails from '@/pages/businessDetails.vue'
import recruitDetails from '@/pages/recruitDetails.vue'
import construction from '@/parts/construction.vue'
import construction1 from '@/parts/construction-1.vue'
import construction2 from '@/parts/construction-2.vue'
import culture from '@/parts/culture.vue'
import notFound from '@/parts/404.vue'

const routes = [
  {
    path: "/",
    name: "home",
    component: home,
  },
  {
    path: "/areas",
    name: "areas",
    component: areas,
  },
  {
    path: "/newsList",
    name: "newsList",
    component: newsList,
  },
  {
    path: "/overview",
    name: "overview",
    component: overview,
  },
  {
    path: "/corporateCulture",
    name: "corporateCulture",
    component: corporateCulture,
    children: [
      {
        path: "construction",
        name: "construction",
        component: construction,
      },
	  {
	    path: "construction1",
	    name: "construction1",
	    component: construction1,
	  },
	  {
	    path: "construction2",
	    name: "construction2",
	    component: construction2,
	  },
      {
        path: "culture",
        name: "culture",
        component: culture,
      },
    ],
  },
  // {
  //   path:'/construction',
  //   name:'construction',
  //   component:construction,
  // },
  // {
  //   path:'/culture',
  //   name:'culture',
  //   component:culture,
  // },
  {
    path:'/contactUs',
    name:'contactUs',
    component:contactUs,
  },
  {
    path:'/recruit',
    name:'recruit',
    component:recruit,
  },
  {
    path:'/essay',
    name:'essay',
    component:essay,
  },
  {
    path:'/businessDetails',
    name:'businessDetails',
    component:businessDetails,
  },
  {
    path:'/recruitDetails',
    name:'recruitDetails',
    component:recruitDetails,
  },
  {
    path:'/notFound',
    name:'notFound',
    component:notFound,
  }
];

const router = createRouter({
  base:'/dist/',
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
